import {
    LIST_RECUSES,
    LIST_RECUSES_SUCCESS,
    LIST_RECUSES_ERROR,
    ADD_RECUSES,
    SAVE_RECUSES,
    SAVE_RECUSES_SUCCESS,
    SAVE_RECUSES_ERROR,
    DELETE_RECUSES,
    DELETE_RECUSES_SUCCESS,
    DELETE_RECUSES_ERROR,
    EDIT_RECUSES,
    UPDATE_RECUSES,
    UPDATE_RECUSES_SUCCESS,
    UPDATE_RECUSES_ERROR
} from '../types';

import clienteAxios from '../config/axios';
import authToken from '../config/token';

import { ErrorMessage, SuccessMessage, WaitingMessage } from '../components/extras/toastMessages';
import { MSG_CREATE_SUCCESS, MSG_UPDATE_SUCCESS, MSG_DELETING, MSG_DELETE_SUCCESS } from '../constants/messages';
import Swal from 'sweetalert2';
import { METHOD_DISABLED } from '../constants/requestMethods';

const controller = 'recusacion';

//LISTAR RECUSES
export function listRecusesAction(params) {
    return async (dispatch) => {
        //Inicializo
        dispatch( listRecuses() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.get(`/${controller}`, { params });
            //Obtengo los datos
            const recuses = response.data;
            //const recuses = recusesData;
            //Llamo al dispatch
            dispatch( listRecusesSuccess(recuses) );
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( listRecusesError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const listRecuses = () => ({
    type: LIST_RECUSES,
    payload: true
});

const listRecusesSuccess = recuses => ({
    type: LIST_RECUSES_SUCCESS,
    payload: recuses
});

const listRecusesError = error => ({
    type: LIST_RECUSES_ERROR,
    payload: error
});

//ADD AUDIENCE CATEGORY
export function addRecusesAction(showForm) {
    return (dispatch) => {
        //Inicializo
        dispatch( addRecuses(false) );
        //Abro el formulario
        showForm();
    }
}

const addRecuses = isEdit => ({
    type: ADD_RECUSES,
    payload: isEdit
});

//SAVE AUDIENCE CATEGORY
export function saveRecusesAction(recuse, handleClose) {
    return async (dispatch) => {
        //Inicializo
        dispatch( saveRecuses() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.post(`/${controller}`, recuse);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( saveRecusesSuccess(response.data) );
            //Cierro la ventana
            handleClose();
            //Mensaje
            SuccessMessage(MSG_CREATE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( saveRecusesError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const saveRecuses = () => ({
    type: SAVE_RECUSES,
    payload: true
});


const saveRecusesSuccess = recuse => ({
    type: SAVE_RECUSES_SUCCESS,
    payload: recuse
});

const saveRecusesError = error => ({
    type: SAVE_RECUSES_ERROR,
    payload: error
});

//EDIT AUDIENCE CATEGORY
export function editRecusesAction(recuse, showForm) {
    return async (dispatch) => {
        //Inicializo
        dispatch( editRecuses(recuse) );
        //Abro el formulario
        showForm();
    }
}

const editRecuses = recuse => ({
    type: EDIT_RECUSES,
    payload: recuse
});

//UPDATE AUDIENCE CATEGORY
export function updateRecusesAction(recuse, handleClose) {
    return async (dispatch) => {
        //Inicializo
        dispatch( updateRecuses() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.put(`/${controller}/${recuse.id}`, recuse);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( updateRecusesSuccess(response.data) );
            //Cierro la ventana
            handleClose();
            //Mensaje
            SuccessMessage(MSG_UPDATE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( updateRecusesError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const updateRecuses = () => ({
    type: UPDATE_RECUSES,
    payload: true
});

const updateRecusesSuccess = recuse => ({
    type: UPDATE_RECUSES_SUCCESS,
    payload: recuse
});

const updateRecusesError = error => ({
    type: UPDATE_RECUSES_ERROR,
    payload: error
});

//DELETE AUDIENCE CATEGORY
export function deleteRecusesAction(recuse) {
    return async (dispatch) => {
        //Inicializo
        dispatch( deleteRecuses() );
        //Mensaje de Espera
        WaitingMessage(MSG_DELETING);
        //Ejecuto la consulta
        try{
            //Hago la consulta
            // const response = await clienteAxios.delete(`/${controller}/${recuse.id}`);
            const response = await clienteAxios.put(`/${controller}/${recuse.id}/${METHOD_DISABLED}`);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( deleteRecusesSuccess(response.data) );
            //Oculto espera
            Swal.close();
            //Mensaje
            SuccessMessage(MSG_DELETE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( deleteRecusesError(data) );
            //Oculto espera
            Swal.close();
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const deleteRecuses = () => ({
    type: DELETE_RECUSES,
    payload: true
});

const deleteRecusesSuccess = recuse => ({
    type: DELETE_RECUSES_SUCCESS,
    payload: recuse
});

const deleteRecusesError = error => ({
    type: DELETE_RECUSES_ERROR,
    payload: error
});